<template>
  <div class="card-default" :class="classNames" :style="cardStyle">
    <slot></slot>
  </div>
</template>

<script>
import Types from '@/utils/types'

export const ColorType = Object.freeze({
  none: 'transparent',
  brand: 'brand-background',
  brand2: 'brand-background-2',
  gray: 'gray-background',
  white: 'white-background'
})

export default {
  name: 'VCard',
  props: {
    radius: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: ColorType.white
    },
    radiusArray: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    cardStyle() {
      return {
        borderRadius:
          this.radiusArray.length === 0
            ? `${this.radius}px`
            : this.radiusArray.reduce((iter, radius) => {
                iter += `${radius}px`
                iter += ' '
                return iter
              }, '')
      }
    },
    classNames() {
      return [this.color]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.card-default {
  // position: relative;
  // width: 100%;
  // height: auto;
  // box-sizing: border-box;
}

.transparent {
  background-color: transparent;
}

.brand-background {
  background-color: $background-brand;
}

.brand-background-2 {
  background-color: $brand;
}

.gray-background {
  background-color: $background-gray;
}

.white-background {
  background-color: $background-white;
}
</style>